module.exports = __webpack_public_path__ + "assets/f3c53e2e63970b6a4c8e72d4069e2051.png";